module.exports = __webpack_public_path__ + "static/fonts/iconfont.be4961e8.ttf";